import React, { useContext } from "react";
import Admin from "./Admin";
import Analitica from "./Analiticas";
import { Router } from "@reach/router";
import { AuthContext } from "../context/AuthContext";
import MobileMenu from "../components/common/MobileMenu";
import PanelNavbar from "../components/global/PanelNavbar";

const Panel = () => {
  const { user, signOut } = useContext(AuthContext);

  return (
    <div className="container-fluid px-0">
      <MobileMenu signOut={signOut} user={user} />
      <div className="sidebar">
        <PanelNavbar user={user} signOut={signOut} />
      </div>
      <div className="main-panel vh-100 bg-light position-relative">
        <div className="content overflow-x-hidden h-100">
          <Router>
            <Admin path="/*" default />
            <Analitica path="/analytics/*" />
          </Router>
        </div>
      </div>
    </div>
  );
};

export default Panel;
